// extracted by mini-css-extract-plugin
export default {"wrapper":"_6cfa14e2"};